import { getDataMapper, mapField, mapArray } from "@/shared";

export const mapContractFromServer = getDataMapper({
    id: mapField("id", Number),
    title: mapField("title"),
    document: mapField("body"),
});

export const mapContractsFromServer = mapArray(mapContractFromServer);
